var prefix = 'sessionAccessId-';

function getId(data) {
    var id;

    if (data && data.id && ~data.id.indexOf(prefix)) {
        id = data.id;
    }

    return id;
}

module.exports = getId;



//////////////////
// WEBPACK FOOTER
// ./node_modules/cross-domain-storage/getId.js
// module id = 1004
// module chunks = 0